<div class="error" role="alert">
  <mat-icon class="error__icon" aria-hidden="true">error_outline</mat-icon>
  <div class="error__text">
    <p class="error__title">Could not load</p>
    <p class="error__message" *ngIf="message; else hint">{{ message }}</p>
    <ng-template #hint>
      <p class="error__message">{{ fallbackMessage }}</p>
    </ng-template>
  </div>
</div>
